module.exports = __webpack_public_path__ + "img/31.79cb8224.png";